// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file bff/admin/admin_user.proto (package com.americanexpress.dining.bff.admin.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ResyUser } from "../../resy/user_pb";
import { file_resy_user } from "../../resy/user_pb";
import type { TockPatron } from "../../tock/patron_pb";
import { file_tock_patron } from "../../tock/patron_pb";
import type { GdusUser } from "../../user/gdus_user_pb";
import { file_user_gdus_user } from "../../user/gdus_user_pb";
import type { ActivateUsersRequestSchema, ActivateUsersResponseSchema, DeactivateUsersRequestSchema, DeactivateUsersResponseSchema, SyncUserRequestSchema, SyncUserResponseSchema, UpdateUserRequestSchema, UpdateUserResponseSchema } from "../../user/user_administration_pb";
import { file_user_user_administration } from "../../user/user_administration_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bff/admin/admin_user.proto.
 */
export const file_bff_admin_admin_user: GenFile = /*@__PURE__*/
  fileDesc("ChpiZmYvYWRtaW4vYWRtaW5fdXNlci5wcm90bxIqY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvIoIBChBBZG1pblVzZXJSZXF1ZXN0EhoKDXNlYXJjaF9zdHJpbmcYASABKAlIAIgBARIRCgRwYWdlGAIgASgFSAGIAQESFgoJcGFnZV9zaXplGAMgASgFSAKIAQFCEAoOX3NlYXJjaF9zdHJpbmdCBwoFX3BhZ2VCDAoKX3BhZ2Vfc2l6ZSK7AQoXQWRtaW5SZXNlcnZhdGlvblN1bW1hcnkSFwoKdmVudWVfbmFtZRgBIAEoCUgAiAEBEhwKD3N0YXJ0X2RhdGVfdGltZRgCIAEoCUgBiAEBEhcKCnBhcnR5X3NpemUYAyABKAVIAogBARITCgZzdGF0dXMYBCABKAlIA4gBAUINCgtfdmVudWVfbmFtZUISChBfc3RhcnRfZGF0ZV90aW1lQg0KC19wYXJ0eV9zaXplQgkKB19zdGF0dXMiyAEKFlJlc2VydmF0aW9uU291cmNlR3JvdXASWQoMcmVzZXJ2YXRpb25zGAEgAygLMkMuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkFkbWluUmVzZXJ2YXRpb25TdW1tYXJ5ElMKBnN0YXR1cxgCIAEoDjJDLmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5SZXNlcnZhdGlvblNvdXJjZVN0YXR1cyKIBAoOQWRtaW5Vc2VyRXZlbnQSXQoRcmVzeV91c2VyX2NyZWF0ZWQYASABKAsyQC5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uUmVzeVVzZXJDcmVhdGVkRXZlbnRIABJhChN0b2NrX3BhdHJvbl9jcmVhdGVkGAIgASgLMkIuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLlRvY2tQYXRyb25DcmVhdGVkRXZlbnRIABJdChFnZHVzX3VzZXJfY3JlYXRlZBgDIAEoCzJALmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5HZHVzVXNlckNyZWF0ZWRFdmVudEgAEmUKFWdkdXNfdXNlcl9kZWFjdGl2YXRlZBgEIAEoCzJELmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5HZHVzVXNlckRlYWN0aXZhdGVkRXZlbnRIABJlChVnZHVzX3VzZXJfcmVhY3RpdmF0ZWQYBSABKAsyRC5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uR2R1c1VzZXJSZWFjdGl2YXRlZEV2ZW50SABCBwoFZXZlbnQiKQoUUmVzeVVzZXJDcmVhdGVkRXZlbnQSEQoJZGF0ZV90aW1lGAEgASgJIisKFlRvY2tQYXRyb25DcmVhdGVkRXZlbnQSEQoJZGF0ZV90aW1lGAEgASgJIikKFEdkdXNVc2VyQ3JlYXRlZEV2ZW50EhEKCWRhdGVfdGltZRgBIAEoCSKTAQoYR2R1c1VzZXJEZWFjdGl2YXRlZEV2ZW50EhEKCWRhdGVfdGltZRgBIAEoCRITCgZyZWFzb24YAiABKAlIAIgBARImChl1cGRhdGVkX2J5X3RvY2tfcGF0cm9uX2lkGAMgASgESAGIAQFCCQoHX3JlYXNvbkIcChpfdXBkYXRlZF9ieV90b2NrX3BhdHJvbl9pZCKTAQoYR2R1c1VzZXJSZWFjdGl2YXRlZEV2ZW50EhEKCWRhdGVfdGltZRgBIAEoCRITCgZyZWFzb24YAiABKAlIAIgBARImChl1cGRhdGVkX2J5X3RvY2tfcGF0cm9uX2lkGAMgASgESAGIAQFCCQoHX3JlYXNvbkIcChpfdXBkYXRlZF9ieV90b2NrX3BhdHJvbl9pZCKWAgoJQWRtaW5Vc2VyEkcKCWdkdXNfdXNlchgBIAEoCzIvLmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLnVzZXIucHJvdG8uR2R1c1VzZXJIAIgBARJHCglyZXN5X3VzZXIYAiABKAsyLy5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5yZXN5LnByb3RvLlJlc3lVc2VySAGIAQESSwoLdG9ja19wYXRyb24YAyABKAsyMS5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy50b2NrLnByb3RvLlRvY2tQYXRyb25IAogBAUIMCgpfZ2R1c191c2VyQgwKCl9yZXN5X3VzZXJCDgoMX3RvY2tfcGF0cm9uInAKEUFkbWluVXNlclJlc3BvbnNlEkkKCmFkbWluVXNlcnMYASADKAsyNS5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uQWRtaW5Vc2VyEhAKCGhhc19tb3JlGAIgASgIIioKFUdldFVzZXJQcm9maWxlUmVxdWVzdBIRCglnZHVzX3V1aWQYASABKAkidwoWR2V0VXNlclByb2ZpbGVSZXNwb25zZRJOCgphZG1pbl91c2VyGAEgASgLMjUuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkFkbWluVXNlckgAiAEBQg0KC19hZG1pbl91c2VyIioKFUdldFVzZXJIaXN0b3J5UmVxdWVzdBIRCglnZHVzX3V1aWQYASABKAkiZAoWR2V0VXNlckhpc3RvcnlSZXNwb25zZRJKCgZldmVudHMYASADKAsyOi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uQWRtaW5Vc2VyRXZlbnQipAEKGkdldFVzZXJSZXNlcnZhdGlvbnNSZXF1ZXN0EhYKDnRvY2tfcGF0cm9uX2lkGAEgASgDEhIKBWxpbWl0GAIgASgFSACIAQESFgoJc2VsZWN0aW9uGAMgASgJSAGIAQESGQoMcmVzeV91c2VyX2lkGAQgASgESAKIAQFCCAoGX2xpbWl0QgwKCl9zZWxlY3Rpb25CDwoNX3Jlc3lfdXNlcl9pZCLbAQobR2V0VXNlclJlc2VydmF0aW9uc1Jlc3BvbnNlEl0KEXRvY2tfcmVzZXJ2YXRpb25zGAEgASgLMkIuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLlJlc2VydmF0aW9uU291cmNlR3JvdXASXQoRcmVzeV9yZXNlcnZhdGlvbnMYAiABKAsyQi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uUmVzZXJ2YXRpb25Tb3VyY2VHcm91cCLWAgoSQWRtaW5Ob3RpZnlTdW1tYXJ5EhcKCnZlbnVlX25hbWUYASABKAlIAIgBARIUCgxub3RpZnlfZGF0ZXMYAiADKAkSIQoUcHJlZmVycmVkX3N0YXJ0X3RpbWUYAyABKAlIAYgBARIfChJwcmVmZXJyZWRfZW5kX3RpbWUYBCABKAlIAogBARIXCgpwYXJ0eV9zaXplGAUgASgFSAOIAQESFwoKY3JlYXRlZF9hdBgGIAEoCUgEiAEBEhMKBnN0YXR1cxgHIAEoCUgFiAEBEhMKBnNvdXJjZRgIIAEoCUgGiAEBQg0KC192ZW51ZV9uYW1lQhcKFV9wcmVmZXJyZWRfc3RhcnRfdGltZUIVChNfcHJlZmVycmVkX2VuZF90aW1lQg0KC19wYXJ0eV9zaXplQg0KC19jcmVhdGVkX2F0QgkKB19zdGF0dXNCCQoHX3NvdXJjZSJ/ChtHZXRVc2VyTm90aWZ5SGlzdG9yeVJlcXVlc3QSFgoOdG9ja19wYXRyb25faWQYASABKAMSEgoFbGltaXQYAiABKAVIAIgBARIZCgxyZXN5X3VzZXJfaWQYAyABKARIAYgBAUIICgZfbGltaXRCDwoNX3Jlc3lfdXNlcl9pZCJwChxHZXRVc2VyTm90aWZ5SGlzdG9yeVJlc3BvbnNlElAKCG5vdGlmaWVzGAEgAygLMj4uY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkFkbWluTm90aWZ5U3VtbWFyeSq6AQoXUmVzZXJ2YXRpb25Tb3VyY2VTdGF0dXMSKQolUkVTRVJWQVRJT05fU09VUkNFX1NUQVRVU19VTlNQRUNJRklFRBAAEiAKHFJFU0VSVkFUSU9OX1NPVVJDRV9TVEFUVVNfT0sQARIkCiBSRVNFUlZBVElPTl9TT1VSQ0VfU1RBVFVTX0ZBSUxFRBACEiwKKFJFU0VSVkFUSU9OX1NPVVJDRV9TVEFUVVNfTk9UX0FQUExJQ0FCTEUQAzKLCwoQQWRtaW5Vc2VyU2VydmljZRKLAQoKU2VhcmNoVXNlchI8LmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5BZG1pblVzZXJSZXF1ZXN0Gj0uY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkFkbWluVXNlclJlc3BvbnNlIgASmQEKDkdldFVzZXJQcm9maWxlEkEuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkdldFVzZXJQcm9maWxlUmVxdWVzdBpCLmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5HZXRVc2VyUHJvZmlsZVJlc3BvbnNlIgASmQEKDkdldFVzZXJIaXN0b3J5EkEuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkdldFVzZXJIaXN0b3J5UmVxdWVzdBpCLmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5HZXRVc2VySGlzdG9yeVJlc3BvbnNlIgASqAEKE0dldFVzZXJSZXNlcnZhdGlvbnMSRi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uR2V0VXNlclJlc2VydmF0aW9uc1JlcXVlc3QaRy5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG8uR2V0VXNlclJlc2VydmF0aW9uc1Jlc3BvbnNlIgASqwEKFEdldFVzZXJOb3RpZnlIaXN0b3J5EkcuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcuYmZmLmFkbWluLnByb3RvLkdldFVzZXJOb3RpZnlIaXN0b3J5UmVxdWVzdBpILmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLmJmZi5hZG1pbi5wcm90by5HZXRVc2VyTm90aWZ5SGlzdG9yeVJlc3BvbnNlIgASjwEKClVwZGF0ZVVzZXISPi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLmFkbWluLnByb3RvLlVwZGF0ZVVzZXJSZXF1ZXN0Gj8uY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcudXNlci5hZG1pbi5wcm90by5VcGRhdGVVc2VyUmVzcG9uc2UiABKJAQoIU3luY1VzZXISPC5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLmFkbWluLnByb3RvLlN5bmNVc2VyUmVxdWVzdBo9LmNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLnVzZXIuYWRtaW4ucHJvdG8uU3luY1VzZXJSZXNwb25zZSIAEp4BCg9EZWFjdGl2YXRlVXNlcnMSQy5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLmFkbWluLnByb3RvLkRlYWN0aXZhdGVVc2Vyc1JlcXVlc3QaRC5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLmFkbWluLnByb3RvLkRlYWN0aXZhdGVVc2Vyc1Jlc3BvbnNlIgASmAEKDUFjdGl2YXRlVXNlcnMSQS5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy51c2VyLmFkbWluLnByb3RvLkFjdGl2YXRlVXNlcnNSZXF1ZXN0GkIuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcudXNlci5hZG1pbi5wcm90by5BY3RpdmF0ZVVzZXJzUmVzcG9uc2UiAEIuCipjb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5iZmYuYWRtaW4ucHJvdG9QAWIGcHJvdG8z", [file_resy_user, file_tock_patron, file_user_gdus_user, file_user_user_administration]);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserRequest
 */
export type AdminUserRequest = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserRequest"> & {
  /**
   * @generated from field: optional string search_string = 1;
   */
  searchString?: string;

  /**
   * 0-indexed page number, defaults to 0
   *
   * @generated from field: optional int32 page = 2;
   */
  page?: number;

  /**
   * results per page, defaults to and capped at 25
   *
   * @generated from field: optional int32 page_size = 3;
   */
  pageSize?: number;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserRequest.
 * Use `create(AdminUserRequestSchema)` to create a new message.
 */
export const AdminUserRequestSchema: GenMessage<AdminUserRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 0);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminReservationSummary
 */
export type AdminReservationSummary = Message<"com.americanexpress.dining.bff.admin.proto.AdminReservationSummary"> & {
  /**
   * @generated from field: optional string venue_name = 1;
   */
  venueName?: string;

  /**
   * ISO-8601 datetime string in venue timezone
   *
   * @generated from field: optional string start_date_time = 2;
   */
  startDateTime?: string;

  /**
   * @generated from field: optional int32 party_size = 3;
   */
  partySize?: number;

  /**
   * e.g. BOOKED, CANCELED, NO_SHOW, LEFT, SEATED — from PartyState
   *
   * @generated from field: optional string status = 4;
   */
  status?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminReservationSummary.
 * Use `create(AdminReservationSummarySchema)` to create a new message.
 */
export const AdminReservationSummarySchema: GenMessage<AdminReservationSummary> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 1);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup
 */
export type ReservationSourceGroup = Message<"com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminReservationSummary reservations = 1;
   */
  reservations: AdminReservationSummary[];

  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus status = 2;
   */
  status: ReservationSourceStatus;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup.
 * Use `create(ReservationSourceGroupSchema)` to create a new message.
 */
export const ReservationSourceGroupSchema: GenMessage<ReservationSourceGroup> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 2);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserEvent
 */
export type AdminUserEvent = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserEvent"> & {
  /**
   * @generated from oneof com.americanexpress.dining.bff.admin.proto.AdminUserEvent.event
   */
  event: {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent resy_user_created = 1;
     */
    value: ResyUserCreatedEvent;
    case: "resyUserCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent tock_patron_created = 2;
     */
    value: TockPatronCreatedEvent;
    case: "tockPatronCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent gdus_user_created = 3;
     */
    value: GdusUserCreatedEvent;
    case: "gdusUserCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent gdus_user_deactivated = 4;
     */
    value: GdusUserDeactivatedEvent;
    case: "gdusUserDeactivated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent gdus_user_reactivated = 5;
     */
    value: GdusUserReactivatedEvent;
    case: "gdusUserReactivated";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserEvent.
 * Use `create(AdminUserEventSchema)` to create a new message.
 */
export const AdminUserEventSchema: GenMessage<AdminUserEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 3);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent
 */
export type ResyUserCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent.
 * Use `create(ResyUserCreatedEventSchema)` to create a new message.
 */
export const ResyUserCreatedEventSchema: GenMessage<ResyUserCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 4);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent
 */
export type TockPatronCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent.
 * Use `create(TockPatronCreatedEventSchema)` to create a new message.
 */
export const TockPatronCreatedEventSchema: GenMessage<TockPatronCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 5);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent
 */
export type GdusUserCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent.
 * Use `create(GdusUserCreatedEventSchema)` to create a new message.
 */
export const GdusUserCreatedEventSchema: GenMessage<GdusUserCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 6);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent
 */
export type GdusUserDeactivatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: optional uint64 updated_by_tock_patron_id = 3;
   */
  updatedByTockPatronId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent.
 * Use `create(GdusUserDeactivatedEventSchema)` to create a new message.
 */
export const GdusUserDeactivatedEventSchema: GenMessage<GdusUserDeactivatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 7);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent
 */
export type GdusUserReactivatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: optional uint64 updated_by_tock_patron_id = 3;
   */
  updatedByTockPatronId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent.
 * Use `create(GdusUserReactivatedEventSchema)` to create a new message.
 */
export const GdusUserReactivatedEventSchema: GenMessage<GdusUserReactivatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 8);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUser
 */
export type AdminUser = Message<"com.americanexpress.dining.bff.admin.proto.AdminUser"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.user.proto.GdusUser gdus_user = 1;
   */
  gdusUser?: GdusUser;

  /**
   * @generated from field: optional com.americanexpress.dining.resy.proto.ResyUser resy_user = 2;
   */
  resyUser?: ResyUser;

  /**
   * @generated from field: optional com.americanexpress.dining.tock.proto.TockPatron tock_patron = 3;
   */
  tockPatron?: TockPatron;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUser.
 * Use `create(AdminUserSchema)` to create a new message.
 */
export const AdminUserSchema: GenMessage<AdminUser> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 9);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserResponse
 */
export type AdminUserResponse = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminUser adminUsers = 1;
   */
  adminUsers: AdminUser[];

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserResponse.
 * Use `create(AdminUserResponseSchema)` to create a new message.
 */
export const AdminUserResponseSchema: GenMessage<AdminUserResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 10);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest
 */
export type GetUserProfileRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest.
 * Use `create(GetUserProfileRequestSchema)` to create a new message.
 */
export const GetUserProfileRequestSchema: GenMessage<GetUserProfileRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 11);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse
 */
export type GetUserProfileResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.bff.admin.proto.AdminUser admin_user = 1;
   */
  adminUser?: AdminUser;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse.
 * Use `create(GetUserProfileResponseSchema)` to create a new message.
 */
export const GetUserProfileResponseSchema: GenMessage<GetUserProfileResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 12);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest
 */
export type GetUserHistoryRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest.
 * Use `create(GetUserHistoryRequestSchema)` to create a new message.
 */
export const GetUserHistoryRequestSchema: GenMessage<GetUserHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 13);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse
 */
export type GetUserHistoryResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminUserEvent events = 1;
   */
  events: AdminUserEvent[];
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse.
 * Use `create(GetUserHistoryResponseSchema)` to create a new message.
 */
export const GetUserHistoryResponseSchema: GenMessage<GetUserHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 14);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest
 */
export type GetUserReservationsRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest"> & {
  /**
   * @generated from field: int64 tock_patron_id = 1;
   */
  tockPatronId: bigint;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string selection = 3;
   */
  selection?: string;

  /**
   * @generated from field: optional uint64 resy_user_id = 4;
   */
  resyUserId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest.
 * Use `create(GetUserReservationsRequestSchema)` to create a new message.
 */
export const GetUserReservationsRequestSchema: GenMessage<GetUserReservationsRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 15);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse
 */
export type GetUserReservationsResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse"> & {
  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup tock_reservations = 1;
   */
  tockReservations?: ReservationSourceGroup;

  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup resy_reservations = 2;
   */
  resyReservations?: ReservationSourceGroup;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse.
 * Use `create(GetUserReservationsResponseSchema)` to create a new message.
 */
export const GetUserReservationsResponseSchema: GenMessage<GetUserReservationsResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 16);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminNotifySummary
 */
export type AdminNotifySummary = Message<"com.americanexpress.dining.bff.admin.proto.AdminNotifySummary"> & {
  /**
   * @generated from field: optional string venue_name = 1;
   */
  venueName?: string;

  /**
   * ISO dates (YYYY-MM-DD), sorted ascending — mirrors Notify.date in reservation.proto
   *
   * @generated from field: repeated string notify_dates = 2;
   */
  notifyDates: string[];

  /**
   * ISO local time (HH:MM[:SS], 24-hour, no timezone), e.g. "17:00" — mirrors Notify.start_time
   *
   * @generated from field: optional string preferred_start_time = 3;
   */
  preferredStartTime?: string;

  /**
   * ISO local time (HH:MM[:SS], 24-hour, no timezone) — mirrors Notify.end_time
   *
   * @generated from field: optional string preferred_end_time = 4;
   */
  preferredEndTime?: string;

  /**
   * @generated from field: optional int32 party_size = 5;
   */
  partySize?: number;

  /**
   * ISO-8601 datetime string in venue timezone
   *
   * @generated from field: optional string created_at = 6;
   */
  createdAt?: string;

  /**
   * ACTIVE | NOTIFIED | FULFILLED | CANCELED
   *
   * @generated from field: optional string status = 7;
   */
  status?: string;

  /**
   * TOCK (reserved for future RESY)
   *
   * @generated from field: optional string source = 8;
   */
  source?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminNotifySummary.
 * Use `create(AdminNotifySummarySchema)` to create a new message.
 */
export const AdminNotifySummarySchema: GenMessage<AdminNotifySummary> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 17);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest
 */
export type GetUserNotifyHistoryRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest"> & {
  /**
   * @generated from field: int64 tock_patron_id = 1;
   */
  tockPatronId: bigint;

  /**
   * defaults to 10
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * reserved for future Resy support; ignored in v1
   *
   * @generated from field: optional uint64 resy_user_id = 3;
   */
  resyUserId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest.
 * Use `create(GetUserNotifyHistoryRequestSchema)` to create a new message.
 */
export const GetUserNotifyHistoryRequestSchema: GenMessage<GetUserNotifyHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 18);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse
 */
export type GetUserNotifyHistoryResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminNotifySummary notifies = 1;
   */
  notifies: AdminNotifySummary[];
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse.
 * Use `create(GetUserNotifyHistoryResponseSchema)` to create a new message.
 */
export const GetUserNotifyHistoryResponseSchema: GenMessage<GetUserNotifyHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 19);

/**
 * @generated from enum com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus
 */
export enum ReservationSourceStatus {
  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_NOT_APPLICABLE = 3;
   */
  NOT_APPLICABLE = 3,
}

/**
 * Describes the enum com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus.
 */
export const ReservationSourceStatusSchema: GenEnum<ReservationSourceStatus> = /*@__PURE__*/
  enumDesc(file_bff_admin_admin_user, 0);

/**
 * @generated from service com.americanexpress.dining.bff.admin.proto.AdminUserService
 */
export const AdminUserService: GenService<{
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.SearchUser
   */
  searchUser: {
    methodKind: "unary";
    input: typeof AdminUserRequestSchema;
    output: typeof AdminUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserProfile
   */
  getUserProfile: {
    methodKind: "unary";
    input: typeof GetUserProfileRequestSchema;
    output: typeof GetUserProfileResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserHistory
   */
  getUserHistory: {
    methodKind: "unary";
    input: typeof GetUserHistoryRequestSchema;
    output: typeof GetUserHistoryResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserReservations
   */
  getUserReservations: {
    methodKind: "unary";
    input: typeof GetUserReservationsRequestSchema;
    output: typeof GetUserReservationsResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserNotifyHistory
   */
  getUserNotifyHistory: {
    methodKind: "unary";
    input: typeof GetUserNotifyHistoryRequestSchema;
    output: typeof GetUserNotifyHistoryResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.SyncUser
   */
  syncUser: {
    methodKind: "unary";
    input: typeof SyncUserRequestSchema;
    output: typeof SyncUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.DeactivateUsers
   */
  deactivateUsers: {
    methodKind: "unary";
    input: typeof DeactivateUsersRequestSchema;
    output: typeof DeactivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.ActivateUsers
   */
  activateUsers: {
    methodKind: "unary";
    input: typeof ActivateUsersRequestSchema;
    output: typeof ActivateUsersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bff_admin_admin_user, 0);

